var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.423 78.8964V86.0688H89.6356L94.8571 100.414H100.423V107.586H97.4679L102.765 122.139L115.969 80.1803L121.94 71.0498V0H86.0781V14.3448H100.423V21.5172H86.0781V35.862H100.423V43.0344H86.0781V57.3792H100.423V64.5516H86.0781V76.2928L87.0249 78.8964H100.423Z",
    fill: "#FFF9E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1947 144.047C84.5125 146.618 89.2172 148.474 94.1271 149.545L99.2159 133.385L66.7034 44.0815L46.4844 51.4404L80.1947 144.047Z",
    fill: "#FFF9E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2572 37.3397L43.1094 10.6907L44.0382 44.6986L64.2572 37.3397Z",
    fill: "#FFF9E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.001 150.62C110.637 150.616 117.196 149.191 123.234 146.439L149.13 93.9585L152.971 73.3701C152.254 73.4419 151.508 73.5638 150.769 73.5638C147.566 73.5761 144.399 72.8856 141.492 71.541C138.585 70.1964 136.008 68.2304 133.943 65.7817L122.506 83.2788L101.348 150.491C102.233 150.542 103.112 150.62 104.001 150.62Z",
    fill: "#FFF9E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.171 65.3267C154.358 69.0169 165.468 62.8917 169.983 51.6453C174.498 40.399 166.544 12.0752 166.544 12.0752C166.544 12.0752 141.215 27.044 136.7 38.2867C132.185 49.5295 135.979 61.6365 145.171 65.3267Z",
    fill: "#FFF9E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.422 121.931C208.526 110.07 208.526 97.9305 206.422 86.0691H154.709C156.758 91.8247 157.802 97.8904 157.793 104C157.793 118.267 152.125 131.949 142.037 142.038C131.949 152.126 118.267 157.793 104 157.793C89.7331 157.793 76.0506 152.126 65.9624 142.038C55.8743 131.949 50.2068 118.267 50.2068 104C50.1979 97.8904 51.2412 91.8247 53.291 86.0691H1.57793C-0.525978 97.9305 -0.525978 110.07 1.57793 121.931H23.4896C25.5684 131.272 29.2575 140.179 34.3917 148.254L18.8993 163.746C25.7775 173.637 34.3632 182.222 44.2537 189.101L59.7461 173.608C67.8211 178.742 76.7284 182.432 86.0688 184.51V206.422C97.9303 208.526 110.069 208.526 121.931 206.422V184.51C131.271 182.432 140.179 178.742 148.254 173.608L163.746 189.101C173.637 182.222 182.222 173.637 189.1 163.746L173.608 148.254C178.742 140.179 182.431 131.272 184.51 121.931H206.422Z",
    fill: "#FFF9E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord17);
export default __webpack_public_path__ + "static/media/accord_17.2bb4d1298a6dfaf86428ad1a01c948ae.svg";
export { ForwardRef as ReactComponent };